export interface Material {
  code                   : string,
  faceprint              : string,
  glovia_description     : string,
  laser_enabled          : boolean,
  material_base          : string,
  material_id            : string,
  material_name          : string,
  material_type          : string,
  name                   : string,
  printer_type           : string,
  subassembly_part_number: string
  coo_code               : string,
  country_origin         : string,
  features               : string
};

export interface ShipmentMaterial {
    materialId    : string,
    impresoName   : string,
    description   : string,
    shortDescript : string,
    quantity      : number,
    weight        : number
};


// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/models/material.model.ts